import {ProductWidget} from '@/lib/TypesOpenApi';
import {ProductBox} from './ProductBox';
import {proxy} from 'valtio';
import {phone} from './phone';
import {DeepReadonly} from '@/lib/typings/readonly';
import {useAnalytics} from '@/hooks/useAnalytics';
import {useCallback} from 'react';

export type BatteryBox = ProductBox<ProductWidget>;

// if add any new field, add the new field to the below reset function also
export const battery = proxy<BatteryBox>({
  // will preselect when widget loaded
  _product: undefined,

  // allow only if phone was selected
  get selected() {
    if (!phone.isActualProduct) {
      return undefined;
    }

    return this._product;
  },

  get productId() {
    return this.selected?.productId;
  },

  get price() {
    return this.selected?.productCost?.units || 0;
  },

  get name() {
    return this.selected?.productName || '';
  },

  get isActualProduct() {
    return this.selected?.isActualProduct;
  },
});

export const resetBattery = () => {
  battery._product = undefined;
};

export const useSetBatteryPlan = () => {
  const analytics = useAnalytics();

  return useCallback(
    (product: DeepReadonly<ProductWidget>) => {
      if (battery.productId !== product.productId) {
        analytics.trackPhoneCardSelection(battery.productId, product.productId);
      }

      battery._product = product as ProductWidget;
    },
    [analytics],
  );
};
